"use client";

import { PageHero } from "@widgets/page-hero";

import type { FilterItemType } from "@shared/content-types/types";
import cardsGrid from "@shared/ui/cards-grid/cards-grid.module.scss";
import { FilterPaginationContainer } from "@shared/ui/filter-pagination-container/filter-pagination-container";
import { PointCard } from "@shared/ui/point-card";

import { getCurrentEquipmentPoint } from "../api";
import type { EquipmentPoints, EquipmentsPageType } from "../model/types";

import s from "./equipments-page.module.scss";

export type EquipmentsPageProps = {
  filters: FilterItemType[];
  content: EquipmentPoints;
  hero: EquipmentsPageType;
};

export const EquipmentsPage = (props: EquipmentsPageProps) => {
  const { filters, content, hero } = props;

  return (
    <main className={s.root}>
      {hero?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={hero?.titleWithIcon}
        />
      )}
      <FilterPaginationContainer
        initialContent={content}
        filters={filters}
        fetchFunction={getCurrentEquipmentPoint}
        renderCard={(card) => (
          <PointCard
            key={card.uid}
            title={card.title}
            clampDescriptionOnMobile
            description={card.description}
            location={card.location}
            phone={card.phone}
            workTimeList={card.workTimeList}
            email={card.email}
            photos={card.photos}
            filters={(card.equipments_types || []).map((t: FilterItemType) => ({
              uid: t.uid,
              label: t.type,
            }))}
          />
        )}
        showFilters={true}
        paginationThreshold={6}
        cardsClassName={cardsGrid.root}
      />
    </main>
  );
};

EquipmentsPage.displayName = "EquipmentsPage";
